import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { appConfig } from './app/app.config';
import { AuthInterceptor } from './app/auth/auth.interceptor';
import { InternetConnectivityInterceptor } from './app/shared/internet-connectivity.interceptor';

bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [
        ...(appConfig.providers || []),
        { provide: HTTP_INTERCEPTORS, useClass: InternetConnectivityInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    ]
}).catch(err => console.error(err));